import React from "react";
import { Alert, Button, Typography, CircularProgress } from "@mui/material";
import RestoreIcon from "@mui/icons-material/Restore";
import { BADGE_COLORS } from "../../../../components/ui/badgeColors";

const alertSx = (color) => ({
    mb: 2,
    backgroundColor: color.bg,
    color: color.text,
    border: `1px solid ${color.border}40`,
    "& .MuiAlert-icon": { color: color.text },
});

/**
 * Aviso inline del conflicto 409 al crear un usuario (TASK-012). Dos variantes
 * según lo que detecta api/usuarios.api.js en el mensaje del backend:
 * - "baja": el username/email pertenece a un usuario dado de baja. Es la
 *   única salida real (el username de un usuario de baja nunca se libera,
 *   ver notas de milestones.md), así que se ofrece restaurar sin abandonar
 *   el modal de creación.
 * - "existente": el username/email pertenece a un usuario activo. Solo se
 *   informa del conflicto; restaurar un usuario activo no tiene sentido, así
 *   que no lleva botón.
 */
const SeccionConflictoCreacion = ({ conflicto, loading, onRestaurar }) => {
    if (!conflicto) return null;

    if (conflicto.tipo === "existente") {
        return (
            <Alert severity="error" sx={alertSx(BADGE_COLORS.RED)}>
                <Typography sx={{ fontSize: { xs: 12, sm: 13 } }}>{conflicto.mensaje}</Typography>
            </Alert>
        );
    }

    return (
        <Alert
            severity="warning"
            sx={alertSx(BADGE_COLORS.AMBER)}
            action={
                <Button
                    onClick={onRestaurar}
                    disabled={loading}
                    size="small"
                    startIcon={
                        loading ? (
                            <CircularProgress size={14} sx={{ color: BADGE_COLORS.AMBER.text }} />
                        ) : (
                            <RestoreIcon sx={{ fontSize: 16 }} />
                        )
                    }
                    sx={{
                        textTransform: "none",
                        fontWeight: 700,
                        color: BADGE_COLORS.AMBER.text,
                        whiteSpace: "nowrap",
                    }}
                >
                    Restaurar usuario en su lugar
                </Button>
            }
        >
            <Typography sx={{ fontSize: { xs: 12, sm: 13 } }}>{conflicto.mensaje}</Typography>
        </Alert>
    );
};

export default SeccionConflictoCreacion;
